
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/calculadora-desconto",
      function () {
        return require("private-next-pages/calculadora-desconto/index.page.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/calculadora-desconto"])
      });
    }
  